module.exports = __webpack_public_path__ + "static/media/checkCircle.8d621312.svg";